import { ListaProblemasModal } from '@atendimento/detail/components/modals/lista-problemas/problemas-modal/ListaProblemasModal'
import { ProblemaCondicaoModel } from '@soap/avaliacao/components/problemas-condicoes/model-problemasCondicoes'
import { useProblemasModalSimplificadoQuery } from 'graphql/hooks.generated'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { Fragment, useEffect, useState } from 'react'
import { FormSpy } from 'react-final-form'
import { Route, RouteComponentProps, useHistory, useRouteMatch } from 'react-router'
import { emptyArrayOf } from 'util/array'
import { CiapCidPreNatal, meta, SoapState } from 'view/atendimentos/atendimento-individual/model'
import { CidadaoFolhaRosto } from 'view/atendimentos/detail/folha-rosto/model'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { ProntuarioCard } from '../ProntuarioCard'
import { concatenarOrigemTagAnalytics } from '../util/analyticsUtils'
import { ProblemasCard } from './ProblemasCard'
import { useFormatProblemas } from './useFormatProblemas'

interface ProblemasSectionProps {
  prontuarioId: ID
  cidadao: CidadaoAtendimento | CidadaoFolhaRosto
  isAtendimentoObservacao: boolean
  problemasAvaliacao?: ProblemaCondicaoModel[]
  problemasLPC?: ReadonlyArray<ProblemaCondicaoModel>
  ciapCidPreNatal?: CiapCidPreNatal
  dataReferencia?: Instant
  readOnly?: boolean
}

export function ProblemasSection(props: Readonly<ProblemasSectionProps>) {
  const {
    prontuarioId,
    cidadao,
    isAtendimentoObservacao,
    problemasAvaliacao = emptyArrayOf<ProblemaCondicaoModel>(),
    problemasLPC = emptyArrayOf<ProblemaCondicaoModel>(),
    dataReferencia,
    ciapCidPreNatal,
    readOnly,
  } = props

  const history = useHistory()
  const match = useRouteMatch()
  const [canRender, setCanRender] = useState(false)
  const { analytics } = useAnalytics()

  const handleClick = () => {
    history.push(`${match.url}/lista-problemas-condicoes`)
    const tag = concatenarOrigemTagAnalytics('acessar_card_problemas', match.url)
    analytics.logEvent(tag)
  }

  const {
    loading,
    data: { problemas },
  } = useProblemasModalSimplificadoQuery({
    variables: { filtro: { prontuarioId } },
  })

  const todosProblemas = useFormatProblemas(problemas?.content, problemasAvaliacao, problemasLPC)
  const problemasExpandido = todosProblemas.getProblemasExpandido()
  const problemasAccordion = todosProblemas.getProblemasAccordion()

  const tooltip = readOnly
    ? problemas?.content?.isNotEmpty()
      ? 'Ver lista de problemas/condições'
      : 'Nenhum problema/condição registrado'
    : canRender
    ? 'Ver ou adicionar problemas/condições'
    : 'Adicionar problemas/condições'

  useEffect(() => {
    setCanRender(problemasExpandido.isNotEmpty())
  }, [problemasExpandido])

  const renderModal = ({ renderProps, formValues }: { renderProps: RouteComponentProps; formValues?: SoapState }) => (
    <ListaProblemasModal
      {...renderProps}
      name={meta.problemasECondicoes}
      prontuarioId={prontuarioId}
      dataAtendimento={dataReferencia}
      isAtendimentoObservacao={isAtendimentoObservacao}
      problemasAvaliacao={formValues?.avaliacao?.problemasECondicoes}
      problemasLPC={formValues?.problemasECondicoes}
      ciapCidPreNatal={ciapCidPreNatal}
      cidadao={cidadao}
      readOnly={readOnly}
    />
  )

  return (
    <Fragment>
      <Route
        path={`${match.url}/lista-problemas-condicoes`}
        render={(renderProps) =>
          readOnly ? (
            renderModal({ renderProps })
          ) : (
            <FormSpy<SoapState> subscription={{ values: true }}>
              {({ values: formValues }) => renderModal({ renderProps, formValues })}
            </FormSpy>
          )
        }
      />
      <ProntuarioCard
        title='Lista de problemas/condições'
        tooltip={tooltip}
        onClick={handleClick}
        dataTestId='ProntuarioCard.Lpc'
      >
        <ProblemasCard
          problemasExpandido={problemasExpandido}
          problemasAccordion={problemasAccordion}
          loading={loading}
          canRender={canRender}
          readOnly={readOnly}
        />
      </ProntuarioCard>
    </Fragment>
  )
}
